import { render, staticRenderFns } from "./SportTabs.vue?vue&type=template&id=2fcfa6aa"
import script from "./SportTabs.vue?vue&type=script&lang=js"
export * from "./SportTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports